/** @module Archive */
define([
	"csi/access/crews",
	"csi/state/rootStore",
	"csi/xml"
], function(crews, {featureTogglesStore}, xml) {

	return {
		/**
		 * Comment
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionArchiveSeason: function(ctx, action) {
			return xml.nodeHasFlag(ctx.getNode(), xml.NODE_FLAG_FROZEN) && featureTogglesStore.ENABLE_ARCHIVING && crews.isAdmin() && crews.isArchiveAdmin(ctx.getContextNode());
		},
		
		/**
		 * Comment
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionArchiveSeasonWithState: function(ctx, action) {
			return this.onAccessActionArchiveSeason(ctx, action) && (ctx.getNode().Status == "SeasonStatus:Complete" || ctx.getNode().Status == "SeasonStatus:CompletedArchivePDFs");
		},

		/**
		 * Comment
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessViewArchivePdf: function(ctx, action) {
			return xml.nodeHasFlag(ctx.getNode(), xml.NODE_FLAG_ARCHIVED_NODE) && featureTogglesStore.ENABLE_ARCHIVING && crews.isArchiveViewer(ctx.getContextNode()) && ctx.getNode().ArchivePDF != "centric:";
		},

		/**
		 * Comment
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessSeasonArchiveReport: function(ctx, action) {
			return xml.nodeHasFlag(ctx, xml.NODE_FLAG_FROZEN) && featureTogglesStore.ENABLE_ARCHIVING && crews.isAdmin() && crews.isArchiveAdmin(ctx) && ctx.Status == "SeasonStatus:Complete";
		},

		/**
		 * Comment
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessTabArchiveJob: function(ctx, action) {
			return featureTogglesStore.ENABLE_ARCHIVING && crews.isAdmin() && crews.isArchiveViewer();
		},
		
		/**
		 * Comment
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessArchiveJobAction: function(ctx, action) {
			return featureTogglesStore.ENABLE_ARCHIVING && crews.isAdmin() && crews.isArchiveAdmin();
		}
	};
});
